import config from './config';

// Rsbuild (Rspack) 兼容性修复
// 使用更通用的方式设置 publicPath
// if (typeof __webpack_public_path__ !== 'undefined') {
//   // eslint-disable-next-line
//   __webpack_public_path__ = `${config.publicPath}/`;
// } else if (typeof __rspack_public_path__ !== 'undefined') {
//   // eslint-disable-next-line
//   __rspack_public_path__ = `${config.publicPath}/`;
// }

__webpack_public_path__ = `${config.publicPath}/`